import React, { useState, useEffect } from "react";
import DashboardLayout from "../common/DashboardLayout";
import TeacherServices from "../../services/TeacherServices";
import CertificationServices from "../../services/CertificationServices";
import { shelterandplace } from '../imagepath';
import { Link } from 'react-router-dom';
import '../../assets/css/certificate.css';
import {
  certificateImg, backgroundcertificateImg
} from "../imagepath";
import { format } from 'date-fns';
import { useParams } from "react-router-dom";

const CertificateList = () => {

  const [certificates, setCertificates] = useState([]);
  const [certificatesData, setCertificatesData] = useState();
  const { teacher_id } = useParams();

  // Parse user once and memoize to prevent infinite loops
  const user = React.useMemo(() => {
    return JSON.parse(localStorage.getItem("user"));
  }, []);

  const role = React.useMemo(() => {
    return localStorage.getItem('userrole');
  }, []);

  // Debug: Log role to console - only on mount
  useEffect(() => {
    console.log("CertificateList - Role:", role, "Type:", typeof role, "User:", user);
    console.log("CertificateList - User role from user object:", user?.role);
    console.log("CertificateList - Window hostname:", window.location.hostname);
  }, []); // Empty dependencies - only run once

  // Determine role for DashboardLayout
  const getRole = () => {
    if (role === "admin" || role == "admin" || user?.role === "admin" || (user && !role && window.location.hostname.includes('admin'))) {
      return "admin";
    }
    if (role == 1 || role === "1") {
      return 1; // School
    }
    if (role == 2 || role === "2") {
      return 2; // School Teacher
    }
    if (role == 3 || role === "3") {
      return 3; // Teacher
    }
    // Default to admin if on admin domain
    if (window.location.hostname.includes('admin')) {
      return "admin";
    }
    return "admin"; // Fallback
  };
  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        let legacyCertificates = [];
        let legacyCertificatesData = null;
        let newCertifications = [];

        // Fetch legacy certificates (historical data)
        try {
          let legacyResponse;
          if (teacher_id) {
            // Call API for specific teacher
            legacyResponse = await TeacherServices.getCertificatesByTeacher(teacher_id);
          } else {
            // Call default API
            legacyResponse = await TeacherServices.getCertificateTitles();
          }

          if (legacyResponse) {
            legacyCertificates = legacyResponse.certificates || [];
            legacyCertificatesData = legacyResponse.quizdata;
          }
        } catch (legacyError) {
          console.log("Legacy certificates not available or error:", legacyError);
        }

        // Fetch new certifications (from new system)
        // Only fetch if viewing own certificates (no teacher_id) or if teacher_id matches current user
        const currentUserId = user?._id || user?.id;
        const isViewingOwnCertificates = !teacher_id || teacher_id === currentUserId;

        if (isViewingOwnCertificates) {
          try {
            const newResponse = await CertificationServices.getMyCertifications();
            if (newResponse && Array.isArray(newResponse)) {
              newCertifications = newResponse;
            } else if (newResponse && Array.isArray(newResponse.certifications)) {
              newCertifications = newResponse.certifications;
            }
          } catch (newError) {
            console.log("New certifications not available or error:", newError);
          }
        } else {
          // If viewing another teacher's certificates, try to fetch via admin endpoint
          try {
            const adminResponse = await CertificationServices.getTeacherCertificationsAsAdmin(teacher_id);
            if (adminResponse && Array.isArray(adminResponse)) {
              newCertifications = adminResponse;
            } else if (adminResponse && Array.isArray(adminResponse.certifications)) {
              newCertifications = adminResponse.certifications;
            }
          } catch (adminError) {
            console.log("Admin certifications not available or error:", adminError);
          }
        }

        // Merge certificates from backend - no filtering needed
        // Backend already returns the correct list of completed certificates
        const mergedCertificates = [...legacyCertificates];

        setCertificates(mergedCertificates);

        // Use legacy data if available, otherwise use first new certification data
        if (legacyCertificatesData) {
          setCertificatesData(legacyCertificatesData);
        } else if (newCertifications.length > 0) {
          // Create certificate data from new certification
          const firstCert = newCertifications[0];
          setCertificatesData({
            name: user?.name || 'Teacher',
            address: user?.address || '',
            completionDate: firstCert.dateCompleted || new Date().toISOString(),
            expirationDate: firstCert.renewByDate || new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString()
          });
        }

      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };

    fetchCertificates();
  }, [teacher_id]); // Only depend on teacher_id - user is memoized and won't change

  const data = {
    centerName: 'My Center',
    address: '326 W60',
    awardDate: 'October 5th 2024',
    expirationDate: 'October 5th 2025'
  };

  const userRole = getRole();
  const userobj = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <DashboardLayout
      role={userRole}
      userType={userobj?.type}
      activeMenu="Certificates"
      layoutType="topnav"
    >
      <div className="cert-lists-div">
        <div className="row">
          {certificates.map((title, index) => (
            <div className="col-xxl-4 col-md-4 d-flex" key={index}>
              <div className="course-box flex-fill">
                <div className="product">
                  <div className="product-img">

                    <Link to={`/viewcertificate/${teacher_id ? teacher_id : user?._id}/${btoa(title)}`}>
                      <div style={{ position: 'relative', width: '220px', height: '170px', backgroundImage: `url(${backgroundcertificateImg})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', color: '#000000', textAlign: 'center', margin: '0px auto', backgroundSize: 'contain', backgroundColor: '#fff', padding: '1px 0px' }}>
                        <h1 className="Certi-heading" >National Certification Program</h1>
                        <p className="certi-sub-heading" >{certificatesData.name}</p>
                        <h2 style={{ fontSize: '8px', marginBottom: '2px' }}>{certificatesData.address}</h2>
                        {/* <p style={{ fontSize: '8px' }}>{data.address}</p> */}
                        <p style={{ fontSize: '8px', fontWeight: '600' }}>Is Awarded & Certified on</p>
                        <p style={{ fontSize: '10px', fontWeight: '600' }}>
                          {format(new Date(certificatesData.completionDate), "MMMM do yyyy")}
                        </p>
                        <p style={{ fontSize: '8px', fontWeight: '600' }}>By the</p>
                        <p style={{ fontSize: '8px', fontWeight: '600' }}>The <span className="certi-pink">Angel</span><span className="certi-blue">Watch</span> Foundation</p>
                        <p style={{ fontSize: '8px' }}>Expiration &nbsp;{format(new Date(certificatesData.expirationDate), "MMMM do yyyy")}
                        </p>
                        <h2 style={{ fontSize: '8px', marginBottom: '2px' }}>{user?.stateid}</h2>
                        <p><img src={certificateImg} className="certi-left-img" /></p>
                        <p><img src={certificateImg} className="certi-right-img" /></p>
                        <p style={{ fontSize: '8px', marginTop: '5px', fontWeight: '600' }}>The <span className="certi-pink">Angel</span><span className="certi-blue">Watch</span> National Accreditation Program for the Safety & Security of Children</p>
                        <p style={{ fontSize: '8px', fontWeight: '600', color: '#4472c4' }}>www.AngelWatch.org | 1-800-381-6794</p>
                      </div>
                    </Link>
                  </div>
                  <div className="product-content">
                    <h3 className="title">
                      <Link to={`/viewcertificate/${teacher_id ? teacher_id : user?._id}/${btoa(title)}`}>
                        {title}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CertificateList;